<template>
  <result-wrapper class="simple-result"
                  icon-name="albums"
                  :element-data="elementData">
    <i class="bi bi-disc ms-2 icons"></i>
    <span class="card-title ms-2">Albums</span>
  </result-wrapper>
</template>

<script>
import ResultWrapper from "@/components/card/ResultWrapper.vue";

export default {
  name: "AlbumsBox",
  props: {
    elementKey: String,
    elementData: Object,
  },
  components: {
    ResultWrapper,
  }
};
</script>

<style lang="scss" scoped></style>